import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import useModalRouter from 'hooks/useModalRouter';

import WhatsappBusinessModal from 'pages/OtherIntegrations/Integrations/Modals/WhatsappBusiness/WhatsappBusinessModal';

import PATHS, { mergePaths } from 'utils/paths';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const WhatsappBusiness = () => {
	const { showModal } = useModalRouter();
	const { pathname } = useLocation();
	const tabs = useMemo(
		() => [
			{
				label: 'whatsappSettings',
				path: mergePaths(PATHS.WHATSAPP, PATHS.WHATSAPP_SETTINGS)
			},
			{
				label: 'whatsappTemplates',
				path: mergePaths(PATHS.WHATSAPP, PATHS.WHATSAPP_TEMPLATES)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lottie-files-compressed/whatsapp-icon-new.json.gz"
				title="whatsappBusiness"
				moduleName="email-whatsapp">
				<Button
					variant="outline"
					label="addConnection"
					className="addButton"
					onClick={() => NiceModal.show(WhatsappBusinessModal)}
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/configuration-icon.json.gz"
				/>
				{pathname === mergePaths(PATHS.WHATSAPP, PATHS.WHATSAPP_SETTINGS) && (
					<Authorization path="/modal/whatsapp-settings-form">
						<Button
							icon={faPlus}
							variant="blue"
							label="addWhatsappSetting"
							lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
							className="addButton"
							disabledTooltip="tooltip.addWhatsappSettings"
							onClick={() => showModal('whatsapp-settings-form')}
						/>
					</Authorization>
				)}
				{pathname === mergePaths(PATHS.WHATSAPP, PATHS.WHATSAPP_TEMPLATES) && (
					<Authorization path="/modal/whatsapp-template-form">
						<Button
							icon={faPlus}
							variant="blue"
							label="addWhatsappTemplate"
							lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
							className="addButton"
							disabledTooltip="tooltip.addWhatsappTemplate"
							onClick={() => showModal('whatsapp-template-form')}
						/>
					</Authorization>
				)}
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default WhatsappBusiness;
